/**
 * @generated SignedSource<<63edef52b04712ea6c42303648d02cb8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tick",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Recurring",
    "kind": "LinkedField",
    "name": "playRecurring",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Recurringtick",
        "kind": "LinkedField",
        "name": "recurringtick",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "recurringPlayMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "recurringPlayMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "7180ece75ec27a8c989e6f2ea9085294",
    "id": null,
    "metadata": {},
    "name": "recurringPlayMutation",
    "operationKind": "mutation",
    "text": "mutation recurringPlayMutation(\n  $request: RecurringPlayRequestInput\n) {\n  playRecurring(request: $request) {\n    id\n    recurringtick {\n      id\n      status\n      tick\n    }\n    tick\n  }\n}\n"
  }
};
})();

node.hash = "85beb1cb8d5d021404e927cb16fcb991";

module.exports = node;
